import "./AddressButton.css";
import BusinessIcon from '@mui/icons-material/Business';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

interface AddressButtonProps {
    address: string[];
    addressFontSize: string;
    addressIconScale: string;
    iconTextGap: string;
}

const AddressButton: React.FC<AddressButtonProps> = ({ address, addressFontSize, addressIconScale, iconTextGap}) => {

    return (
        <Button className='address-button' href={`${process.env.REACT_APP_MAPS_QUERY}`} target="_blank" rel="noopener noreferrer" sx={{gap: `${iconTextGap}`}}>
            <Box className='address-icon'>
                <BusinessIcon sx={{ scale: `${addressIconScale}`, color: 'var(--color-palette-4)' }} />            
            </Box>
            <Box className="address-text" sx={{ fontSize: addressFontSize }}>
                {address.map((line, index) => (
                    <Box key={index} className="address-line">
                        {line}
                    </Box>
                ))}
            </Box>
        </Button>
    );
};

export default AddressButton;